import { Sparkle } from "lucide-react";
import { Fragment } from "react";

const ITEMS = [
  "Electronics & Gadgets",
  "Home & Kitchen",
  "Fashion & Accessories",
  "Beauty & Care",
  "Baby Essentials",
  "Toys & Games",
  "Best Sellers",
  "Editor's Choice",
  "Prime Eligible",
  "Updated Weekly",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <Fragment key={item}>
        <span className="whitespace-nowrap px-8 font-display text-2xl md:text-3xl font-bold uppercase tracking-tight text-slate-600">
          {item}
        </span>
        <Sparkle size={18} className="shrink-0 text-[#FF9900]" />
      </Fragment>
    ))}
  </div>
);

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="relative overflow-hidden border-y border-white/10 bg-[#121418]/60 py-6"
    aria-hidden
  >
    <div className="animate-marquee flex w-max">
      <Row />
      <Row />
    </div>
  </div>
);
